import { render, staticRenderFns } from "./SuperAdminShell.vue?vue&type=template&id=73f20a4a&"
import script from "./SuperAdminShell.vue?vue&type=script&lang=ts&"
export * from "./SuperAdminShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports